"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetType_VendorLogo = exports.Types_VendorLogo = exports.CONST_KnownCsvParserTypes = void 0;
exports.CONST_KnownCsvParserTypes = ['konges & marmar-old', 'buho', 'marmar', 'emile-et-ida'];
exports.Types_VendorLogo = ['vendor-logo'];
exports.AssetType_VendorLogo = {
    fileTypes: ['png', 'jpeg', 'jpg'],
    key: 'vendor-logo'
};
